import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Input, InfoTooltip } from 'ui';
import styled from 'styled-components';
import debounce from 'lodash.debounce';
import { Action } from './value-filter';

const Title = styled.div`
  font-weight: 400;
  font-size: 16px;
`;

const StyledInput = styled(Input)`
  width: ${p => p.isColumnFilter ? '100%' : '90%'} !important;
`;

const InputFilter = ({
  description,
  onChange,
  activeFilters,
  intl,
  isColumnFilter,
  needsConfirm,
  info = '',
}) => {
  const [value, setValue] = useState();

  useEffect(() => {
    if (activeFilters?.length) {
      setValue(activeFilters[0]);
    }
  }, []);

  useEffect(() => {
    if (activeFilters?.length && activeFilters[0] !== value) {
      // only do this if the user is not typing (so one of the 2 fields is empty)
      if (!activeFilters[0] || !value) {
        setValue(activeFilters[0]);
      }
    }
  }, [activeFilters]);

  const updateFilter = useCallback(
    debounce(v => onChange([v]), 300),
    [onChange],
  );

  const onInputChange = (e) => {
    if (!needsConfirm) {
      updateFilter(e.target.value);
    }
    setValue(e.target.value);
  };

  return (
    <>
      {!isColumnFilter && <Title>
        {description.toUpperCase()}
        <InfoTooltip content={info} />
      </Title>
      }
      <StyledInput
        value={value}
        onChange={onInputChange}
        placeholder={intl.formatMessage({
          id: 'common.titles.SEARCH',
        })}
        isColumnFilter={isColumnFilter}
      />
      {needsConfirm && <Action
        type='secondary'
        onClick={() => onChange(value)}
      >
        {intl.formatMessage({ id: 'worklist.filters.APPLY' })}
      </Action>
      }
    </>
  );
};

export default injectIntl(InputFilter);

InputFilter.propTypes = {
  description: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  activeFilters: PropTypes.array,
  intl: PropTypes.object,
  isColumnFilter: PropTypes.bool,
  needsConfirm: PropTypes.bool,
  info: PropTypes.string,
};
